<template>
  <div class="Capture">

    <canvas ref="canvas" class="Capture__canvas" />

    <img style="display: none" ref="welcome" :src="require('@/pages/marker/markers/singer/welcome_' + lang + '.png')" />
    <img style="display: none" ref="pallette" :src="require('@/pages/marker/markers/singer/pallette.png')" />

    <transition name="Capture__look">
      <div class="Capture__look" :class="['is-' + $route.meta.name]" v-if="!found && $route.meta.name == 'marker'">
        <div class="Capture__look-marker">
          <img :src="require('@/pages/marker/markers/' + $route.params.marker + '/capture.png')" />
        </div>
      </div>
    </transition>

    <transition name="Capture__btn">
      <div class="Capture__btn disable-force-touch" v-if="$route.meta.name == 'marker'" @click="capture">
        <img :src="require('./img/take.png')" />
      </div>
    </transition>

    <transition name="Capture__share">
      <div class="Capture__share" v-if="image">
        <img :src="image" class="disable-force-touch" />
        <div class="Capture__share-container">
          <div class="Btn is-facebook" v-if="response" @click="share">
            <img :src="require('@/pages/home/img/facebook.png')" />
            {{ trans('share') }}
          </div>
          <div class="Btn is-loader" v-else="response"><div class="Capture__spin" /></div>

          <a class="Btn" :href="image" download="capture.png" v-if="!ios">{{ trans('download') }}</a>
          <!--div v-else class="Capture__hold disable-force-touch" v-html="trans('hold')" /-->
        </div>
        <div class="Capture__back disable-force-touch" @click="image = null">
          <img :src="require('./img/Back.png')" />
        </div>
        <div class="Capture__top-text">
          <span v-if="$route.meta.name == 'selfie' && shared == 0">{{ trans('share2') }}</span>
          <span v-if="$route.meta.name == 'selfie' && shared == 1">{{ trans('share1') }}</span>
        </div>
      </div>
    </transition>


    <transition name="Capture__marker-text">
      <div class="Capture__marker-text" v-if="!found && $route.meta.name == 'marker'">
        {{ trans('markers.' + $route.params.marker) }}
      </div>
    </transition>

    <div class="Capture__close disable-force-touch" @click="close">
      <img :src="require('./img/Close.png')" />
    </div>

  </div>
</template>

<script>
export default {
  name: 'Capture',
  props: ['found'],
  data: () => ({
    image: null,
    step: 'save',
    response: null,
    ios: false
  }),
  beforeDestroy() {
    this.deleteImage()
  },
  watch: {
    image() {
      const crownParticules = this.$parent.$el.querySelector('.Crown__particules')

      if(crownParticules)
        TweenMax.to(crownParticules, .5, { autoAlpha: this.image ? 0 : 1 })

      if(this.image === null)
        this.deleteImage()

      if(this.image)
        this.$nextTick(this.disableForceTouch)
    }
  },
  created() {
    const param = this.$route.meta.name == 'selfie' ? this.$route.params.effect : this.$route.params.marker

    this.ios = /iphone|ipod|ipad/.test(window.navigator.userAgent.toLowerCase())


    dataLayer.push({
      "useCaseStep": { "Id": "UCS540 - Game experience - Camera page | PV", "trackType": "PV" },
      "event": "VPV",
      "page": {
        ...this.tracking.page,
        contentName: "experience",
        gaStep: "experience-camera",
        requestURI: this.tracking.page.requestURI + "experience-camera",
      },
      show: this.tracking.show,
      photo: {
        cameraSide: this.$route.meta.name == 'selfie' ? 'selfie' : 'environment',
        filterName: param,
        savedNumber: null
      }
    })
  },
  computed: {
    shared() { return this.$store.getters['user/shared'] },
  },
  translations: {
    en: {
      hold: 'TOUCH AND HOLD<br> IMAGE TO SAVE',
      download: 'Download your photo',
      share2: 'Share two photos on Facebook and get 15% off merchandise today.',
      share1: "Share an additional photo to get 15% off merchandise today.",
      share: 'SHARE ON FACEBOOK',
      markers: {
        trone: 'Look for the marker and see Mr. Fleur come alive',
        mrfleur: 'Look for the marker and see Mr. Fleur come alive',
        crown: 'Look for the marker and see the crown come alive',
				card: 'Look for the marker and see the cards come alive',
				singer: 'Look for the marker and see the white singer come alive'
      }
    },
    fr: {
      hold: 'TOUCHER ET MAINTENIR<br> POUR SAUVEGARDER',
      download: 'Télécharger votre photo',
      share2: "Partagez deux photos sur Facebook et obtenez 15% de rabais sur la marchandise aujourd'hui.",
      share1: "Partagez une deuxième photo pour obtenir 15% de rabais sur la marchandise aujourd'hui.",
      share: 'PARTAGER SUR FACEBOOK',
      markers: {
        trone: "Repérez l'icône et voyez M. Fleur s'animer",
        mrfleur: "Repérez l'icône et voyez M. Fleur s'animer",
				crown: "Repérez l'icône et voyez la couronne s'animer",
				card: "Repérez l'icône et voyez les cartes s'animer",
				singer: "Repérez l'icône et voyez la chanteuse en blanc s'animer"
      }
    },
  },
  methods: {
    close() {
      this.image = null
      this.$router.push({ name: 'map.' + this.lang })
    },
    deleteImage() {
      const form = new FormData
      form.append('path', this.response.path)

      this.$http_origin.post('delete_image', form).then(response => {
        console.log('delete')
      })

      this.response = null
    },
    trackDownload() {
      console.log('track download')
      dataLayer.push({
        "useCaseStep": { "Id": "UCS544 - Game experience - Click to Download picture | Non PV", "trackType": "Non PV" },
        "event": "userAction",
        "eventCategory": "AR-event",
        "eventAction": "AlegriaAR-downloadPicture",
        "eventLabel": this.$route.meta.name + '-' + param,
      })
    },
    share() {
      const param = this.$route.meta.name == 'selfie' ? this.$route.params.effect : this.$route.params.marker

      dataLayer.push({
        "useCaseStep": { "Id": "UCS543 - Game experience - Click to Share picture | Non PV", "trackType": "Non PV" },
        "event": "userAction",
        "eventCategory": "AR-event",
        "eventAction": "AlegriaAR-sharePictureFacebook",
        "eventLabel": this.$route.meta.name + '-' + param,
        "photo": {
            cameraSide: this.$route.meta.name == 'selfie' ? 'selfie' : 'environment',
            "filterName": param,
            "savedNumber": this.response.id
        }
      })

      const hash = this.$route.params.marker == 'mrfleur' || this.$route.params.marker == 'trone' || this.$route.params.marker == 'crown'
      ? this.trans('hash').replace('#', '')
      : 'null'

      const dpr = window.devicePixelRatio || 1
      const size = {
        w: window.innerWidth * dpr,
        h: window.innerHeight * dpr,
      }

      const url = window.location.origin + '/share/' + hash + '/' + size.w + '/' + size.h + '?url=' + this.response.url

      // console.log(url)

      FB.ui({
        display: 'popup',
        method: 'share',
        href: url,
      }, response => {
        if(response && !response.error_message) {
          this.image = null

          this.$store.commit('user/ADD_SHARE')

          if(this.$route.meta.name == 'marker')
            this.$router.push({ name: 'map.' + this.lang })
        }
      })
    },
    dataURLtoFile(base64) {
      var base64data = base64.replace("data:image/png;base64,", "")
      var bs = atob(base64data)
      var buffer = new ArrayBuffer(bs.length)
      var ba = new Uint8Array(buffer)
      for (var i = 0; i < bs.length; i++) {
        ba[i] = bs.charCodeAt(i)
      }
      var file = new Blob([ba], { type: "image/png" })
      return file
    },
    upload() {
      const form = new FormData
      const file = this.dataURLtoFile(this.image)
      form.append('image', file)

      this.$http_origin.post('save_image', form).then(response => {
        this.response = response.data
      })
    },

    capture() {
      const param = this.$route.meta.name == 'selfie' ? this.$route.params.effect : this.$route.params.marker

      dataLayer.push({
        "useCaseStep": { "Id": "UCS541 - Game experience - Click to take picture | Non PV", "trackType": "Non PV" },
        "event": "userAction",
        "eventCategory": "AR-event",
        "eventAction": "AlegriaAR-takePicture",
        "eventLabel": this.$route.meta.name + '-' + param
      })

      dataLayer.push({
        "useCaseStep": { "Id": "UCS542 - Game experience - Taken picture page | PV", "trackType": "PV" },
        "event": "VPV",
        "page": {
          contentName: "experience",
          gaStep: "experience-picture",
          requestURI: this.tracking.page.requestURI + "experience-picture",
        },
        show: this.tracking.show,
        photo: {
          cameraSide: this.$route.meta.name == 'selfie' ? 'selfie' : 'environment',
          "filterName": param,
          "savedNumber": null
        }
      })

      this.$refs.canvas.width = window.innerWidth
      this.$refs.canvas.height = window.innerHeight
      // const ctx = this.$refs.canvas.getContext("2d")
      const ctx = this.setupCanvas(this.$refs.canvas)

      if(this.$route.meta.name == 'marker') {
        const image = new Image()
        const imageParticule = new Image()
        const canvasParent = this.$parent.$el.querySelector('.Marker__canvas')
        const videoParent = this.$parent.$el.querySelector('video')
        const crownParticules = this.$parent.$el.querySelector('.Crown__particules')
        const cb = canvasParent.getBoundingClientRect()
        const vb = videoParent.getBoundingClientRect()
        const base64 = this.$parent.$refs.canvas.toDataURL('png')

        ctx.drawImage(videoParent, vb.left, vb.top, vb.width, vb.height)
        image.src = base64

        image.onload = () => {
          if(this.$route.params.marker == 'singer') {
            ctx.drawImage(this.$refs.pallette, 0, 0, window.innerWidth, window.innerHeight)
            ctx.drawImage(this.$refs.welcome, (window.innerWidth - 220) / 2, 30, 220, 67)
          }
          ctx.drawImage(image, cb.left, cb.top, cb.width, cb.height)

          if(crownParticules) {
            imageParticule.src = crownParticules.toDataURL('png')
            imageParticule.onload = () => {
              ctx.drawImage(imageParticule, 0, 0, window.innerWidth, window.innerHeight)
              this.image = this.$refs.canvas.toDataURL('png')
              this.upload()
            }
          } else {
            this.image = this.$refs.canvas.toDataURL('png')
            this.upload()
          }
        }
      } else {
        const canvas = this.$parent.$refs.imageData
        const canvas3D = this.$parent.$refs.t3d
        const imageCanvas = canvas.toDataURL('png')
        const imageCanvas3D = canvas3D.toDataURL('png')
        const c = canvas.getBoundingClientRect()
        const c3d = canvas3D.getBoundingClientRect()
        const ci = new Image()

        ci.onload = () => {
          ctx.drawImage(ci, c.left, c.top, c.width, c.height)
          const ci3d = new Image()
          ci3d.onload = () => {
            ctx.drawImage(ci3d, c3d.left, c3d.top, c3d.width, c3d.height)
            this.image = this.$refs.canvas.toDataURL('png')
            this.upload()
          }
          ci3d.src = imageCanvas3D
        }


        ci.src = imageCanvas
      }
    },
    setupCanvas(canvas) {
      var dpr = window.devicePixelRatio || 1
      canvas.width = window.innerWidth * dpr
      canvas.height = window.innerHeight * dpr
      var ctx = canvas.getContext('2d')
      ctx.scale(dpr, dpr)
      return ctx
    }
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Capture
  position absolute
  top 0px
  left 0px
  right 0px
  bottom 0px

  .Btn.is-loader
    position relative

  &__close
    position absolute
    top 25px
    right 25px
    width 28px
    height 28px
    padding 4px
    display block
    box-sizing border-box
    z-index 99999

  &__back
    position absolute
    top 27px
    left 25px
    width 32px
    height 28px
    padding 4px
    display block
    box-sizing border-box

  &__marker-text
  &__top-text
    position absolute
    left 0px
    top 0px
    right 0px
    padding 20px 70px
    text-align center
    color white
    font-weight 700
    font-size 14px
    line-height 22px
    z-index 99999
    text-shadow 0px 0px 5px rgba(black, .7)
    letter-spacing .05em

  &__hold
    position absolute
    bottom 80px
    line-height 30px
    left 40px
    right 40px
    text-align center
    text-shadow 0px 0px 5px rgba(black, .7)
    pointer-events none

  &__marker-text
    text-align left
    padding-left 30px
    padding-top 25px
    z-index 1
    transition opacity 1s
    &-enter
    &-leave-active
      opacity 0

  &__spin
    position absolute
    top 50%
    left 50%
    margin -12px 0 0 -10px
    border 2px solid rgba(grey, 1)
    border-top 2px solid rgba(black, .1)
    border-radius 50%
    width 20px
    height 20px
    animation Loader__spin 2s linear infinite

    @keyframes Capture__spin {
      from { transform: rotate(0deg) }
      to { transform: rotate(360deg) }
    }

  &__canvas
    background red
    position absolute
    width 100%
    height 100%
    background rgba(red, .3)
    left 0px
    top 0px
    display none

  &__share-container
    position absolute
    bottom 60px
    left 50%
    transform translateX(-50%)

  &__look
    position absolute
    top 50%
    left 50%
    width 234px
    height 226px
    z-index 99
    transform translate(-50%, -50%)
    transition opacity 1s
    background-image url('./img/viseur.png')
    background-size contain
    &-marker
      opacity .8
      padding 50px 60px 60px 60px
    &-enter
    &-leave-active
      opacity 0

  &__btn
    position absolute
    bottom 68px
    left 50%
    transform translateX(-50%)
    width 68px
    height 68px
    transition opacity 1s
    &-enter
    &-leave-active
      opacity 0

  &__share
    position absolute
    left 0px
    top 0px
    bottom 0px
    right 0px
    z-index 9999
    transition opacity 1s, transform 1s
    &-enter
    &-leave-active
      opacity 0
      transform scale(1.2)
    &-title
      position absolute
      left 0px
      right 0px
      text-align center
      top 50px
      line-height 30px



</style>
